import { AppSettings } from 'app/sharedcomponents/_common/constants/app.constants';
import { Location, PlatformLocation } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { Router } from "@angular/router";
import { overlayConfigFactory } from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import { TranslateService } from "ng2-translate/ng2-translate";
import { Observable } from "rxjs/Observable";
import {
  PickupType,
  SendMoneyDetail,
  SendMoneyProgramDetail,
  SendMoneySteps
} from "../models/sendmoney/sendmoney";
import { BeneficiaryComponent } from "../sendMoney/beneficiary/beneficiary.component";
import { PaymentTypeComponent } from "../sendMoney/payment-type/payment-type.component";
import { PickupCenterComponent } from "../sendMoney/pickup-center/pickup-center.component";
import { PickupTypeComponent } from "../sendMoney/pickup-type/pickup-type.component";
import { SummaryComponent } from "../sendMoney/summary/summary.component";
import { InfoPopupComponent } from "../sharedcomponents/_directive/info-popup/info-popup.component";
import { SendMoneyService } from "../_services/sendmoneyservice/sendmoneyservice";
import { SummarydetailPopupComponent } from "./_modalpopup/summarydetail-popup/summarydetail-popup.component";
import { Ng2DeviceService } from "ng2-device-detector";
@Component({
  selector: "app-sendmoney",
  templateUrl: "./sendMoney.component.html",
  providers: [Modal],
  styleUrls: ["./sendMoney.component.css"]
})
export class SendmoneyComponent implements OnInit, OnDestroy {
  sendMoneyDetail: SendMoneyDetail;
  tabFlag: false;
  PageFlow: any = {};
  headertext: string = "";
  lastIndex: any;

  public selectedIndex: 0;
  private subModalpopup: any;
  public tabs = [
    {
      label: "SendMoney_pickupType",
      labelHead: "RepeatOrderDetail_lblEditPickupType",
      index: 0
    },
    {
      label: "SendMoney_pickupCenter",
      labelHead: "SendMoney_pickupCenter",
      index: 1
    },
    {
      label: "SendMoney_beneficiary",
      labelHead: "SendMoney_beneficiary",
      index: 2
    },
    {
      label: "SendMoney_paymentType",
      labelHead: "RepeatOrderDetail_lblEditPaymentType",
      index: 3
    },
    {
      label: "SendMoney_summary",
      labelHead: "RepeatOrderDetail_lblOrderSummary",
      index: 4
    }
  ];

  private tabContentComponents: any[] = [
    PickupTypeComponent,
    PickupCenterComponent,
    BeneficiaryComponent,
    PaymentTypeComponent,
    SummaryComponent
  ];

  @ViewChild("tabContent", { read: ViewContainerRef })
  tabContent: ViewContainerRef;
  @ViewChild("tabHeader") tabHeader: ViewChild;

  constructor(
    private cfr: ComponentFactoryResolver,
    public translate: TranslateService,
    private sendMoneyService: SendMoneyService,
    private router: Router,
    private ref: ChangeDetectorRef,
    private modal: Modal,
    public location: Location,
    public platformLocation: PlatformLocation,
    private deviceService: Ng2DeviceService,
    private vcRef: ViewContainerRef
  ) {
    // location.subscribe((e: any) => {
    //   location.replaceState('/dashboard');
    //   return;
    // });

    // platformLocation.onPopState(e => {
    //   this.router.navigate(['/dashboard']);
    //   return;
    // });
    const path = this.router.url.split("/")[1];
    if (
      path == "repeatorder" ||
      path == "sendmoneysummary" ||
      path == "sendmoney"
    ) {
      // this.sendMoneyService.setPageFlow(path);
      this.sendMoneyService.setPageFlow(
        path == "repeatorder" || path == "sendmoneysummary"
          ? "repeatorder"
          : "sendmoney"
      );
      sessionStorage.PageFlow =
        path == "repeatorder" || path == "sendmoneysummary"
          ? "repeatorder"
          : "sendmoney";
      if (path == "sendmoney") {
        sessionStorage.RepeatOrderFlow = "";
      }
    }
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    this.PageFlow.Value = sessionStorage.PageFlow;
    if (this.PageFlow.Value == "repeatorder") {
      if (
        this.sendMoneyDetail.agentDetails.CountryTo == "" ||
        this.sendMoneyDetail.agentDetails.CountryTo == undefined
      ) {
        if (
          sessionStorage.RepeatOrderFlow != undefined &&
          sessionStorage.RepeatOrderFlow != ""
        ) {
          this.router.navigate(["/" + sessionStorage.RepeatOrderFlow]);
        } else {
          this.router.navigate(["/repeatorderlist"]);
        }
        return;
      }
    } else if (this.PageFlow.Value == "sendmoney") {
      if (this.sendMoneyDetail.isData == false) {
        this.router.navigate(["/dashboard"]);
      }
    }
    // this.sendMoneyService.getPageFlow().subscribe(data => {
    //   this.PageFlow = data;
    // });

    if (this.sendMoneyService.isFirstTime()) {
      this.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    let selectedI: any;
    let _self=this;
    let flag: boolean = true;
    // this.subModalpopup = this.sendMoneyService.getModalPopup().subscribe(data => {
    //   selectedI = data.data;
    //   if (data.data > 0) {
    //     flag = false;
    //   }
    // });

    // if (flag != true) {
    //   this.onTabChange(selectedI - 1, false);
    //   this.headertext = this.tabs.filter((item, i) => i === this.selectedIndex)[0].labelHead;
    //   if (this.headertext == 'SendMoney_pickupCenter') {
    //     this.headertext = this.loadPickupTypeText(this.sendMoneyDetail.pickupTypeDetails.pickupType);
    //   }
    // }
    if (this.sendMoneyDetail.isData == true && flag == true) {

      return Observable.create(observer => {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        let loading = false;
        modalData.Title = this.translate.instant("Common_lblConfirm");
        modalData.Message = this.translate.instant(
          "SendMoney_navigateConfirmDesc"
        );
        this.modal
          .open(
            InfoPopupComponent,
            overlayConfigFactory({ modalData }, BSModalContext)
          )
          .then(function(obj) {
            obj.onDestroy.subscribe(data => {
              if (modalData.next == "yes") {
                let DeviceDetail = _self.deviceService.getDeviceInfo();
                (<any>window).firebase
                  .analytics()
                  .logEvent("UnfinishedTransaction", {
                    Step: _self.getScreen(_self.selectedIndex),
                    Platform: AppSettings.Platform,
                    Browser: DeviceDetail.browser,
                    OSVersion: DeviceDetail.os_version,
                    AppVersion: AppSettings.Appversion
                  });
                observer.next(true);
                observer.complete();
              } else {
                observer.next(false);
                observer.complete();
              }
            });
          });
      });
    }
    return flag;
  }

  ngOnInit() {
    this.subModalpopup = this.sendMoneyService
      .getModalPopup()
      .subscribe(data => {
        if (this.selectedIndex !== data.data) {
          // this.selectedIndex = data.data;
          this.onTabChange(data.data, data.isLoad);
          this.headertext = this.tabs.filter(
            (item, i) => i === this.selectedIndex
          )[0].labelHead;
          if (this.headertext == "SendMoney_pickupCenter") {
            this.headertext = this.loadPickupTypeText(
              this.sendMoneyDetail.pickupTypeDetails.pickupType
            );
          }
          /// this.ref.detectChanges();
        }
      });
  }

  onTabClick(tab) {
    let selTab;
    if (tab.target != undefined) {
      selTab = tab.target.innerText;
    } else {
      selTab = tab.srcElement.outerText;
    }
    // commented summary detail popup - customer has requested this
    // if (this.translate.instant(this.tabs[4].label).toLowerCase() == selTab.toLowerCase() && (Number(this.selectedIndex) == 2 || Number(this.selectedIndex) == 3)) {
    //   this.modal.open(SummarydetailPopupComponent, overlayConfigFactory({}, BSModalContext));
    //   let obj: any = this.tabHeader;
    //   obj.selectedIndex = this.selectedIndex;
    //   return;
    // }

    //let obj = this.tabs.filter((item, i) => this.translate.instant(item.label) == selTab);
    let obj = this.tabs.filter(
      (item, i) =>
        this.translate.instant(item.label).toLowerCase() == selTab.toLowerCase()
    );
    if (obj.length > 0) {
      this.onTabChange(obj[0].index, false);
    }
  }
  onTabChange(tabIndex, isLoad) {
    // set default data to program id
    try {
      this.sendMoneyService.getSendMoneyProgramDetailData().subscribe(data => {
        this.sendMoneyDetail.sendMoneyProgramDetail = data;
      });

      if (this.sendMoneyDetail.sendMoneyProgramDetail.FromPage == "summary") {
        let sendMoneyProgramDetail = new SendMoneyProgramDetail();
        this.sendMoneyDetail.sendMoneyProgramDetail.ProgramId="0";
        this.sendMoneyService.setSendMoneyProgramDetailData(
          this.sendMoneyDetail.sendMoneyProgramDetail
        );
      }
    } catch (error) {}

    this.selectedIndex = tabIndex;
    const factory = this.cfr.resolveComponentFactory(
      this.tabContentComponents[tabIndex]
    );
    this.tabContent.clear();
    this.sendMoneyService.setModalPopup(tabIndex);
    const instance: any = this.tabContent.createComponent(factory).instance;
  }
  ngOnDestroy() {
    if (this.subModalpopup != undefined) {
      this.subModalpopup.unsubscribe();
    }
  }
  enableTab(index) {
    return index < this.selectedIndex ? false : true;
    // commented below code - orange tab disabled ==> customer has requested this change
    // if (index == 4) {
    //   return this.selectedIndex >= 2 ? false : true;
    // } else {
    //   return index < this.selectedIndex ? false : true;
    // }
  }

  loadPickupTypeText(type) {
    let classVal;
    switch (parseInt(type, 0)) {
      case PickupType.atmDeposit: {
        classVal = this.translate.instant("PickupTypeLabels_lblAtmDeposit");
        break;
      }
      case PickupType.bankDeposit: {
        classVal = this.translate.instant("PickupTypeLabels_lblBankDeposit");
        break;
      }
      case PickupType.homeDelivery: {
        classVal = this.translate.instant("PickupTypeLabels_lblHomeDelivery");
        break;
      }
      case PickupType.officePickup: {
        classVal = this.translate.instant("PickupTypeLabels_lblOfficePickup");
        break;
      }
    }
    return classVal;
  }

  getScreen(type) {
    let classVal;
    switch (parseInt(type, 0)) {
      case SendMoneySteps.PickupType: {
        classVal = "PickupType";
        break;
      }
      case SendMoneySteps.PickupCenter: {
        classVal = "PickupCenter";
        break;
      }
      case SendMoneySteps.Beneficiary: {
        classVal = "Beneficiary";
        break;
      }
      case SendMoneySteps.PaymentType: {
        classVal = "PaymentType";
        break;
      }
      case SendMoneySteps.Summary: {
        classVal = "Summary";
        break;
      }
    }
    return classVal;
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/sendmoney.component.ts